export enum GameState {
    WaitResult = 2,
    Fish = 0x7000,
    Calabash,
    Tiger,
    Crab,
    Prawn,
    Rooster
}